module.exports = __webpack_public_path__ + "img/logo.11886d51.png";